module.exports = __webpack_public_path__ + "img/26.710f7de0.png";